/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Fact_PayInputs */

const en_coaches_page_fact_pay = /** @type {(inputs: Coaches_Page_Fact_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pay and cancel in the app`)
};

const pl_coaches_page_fact_pay = /** @type {(inputs: Coaches_Page_Fact_PayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Płacisz i odwołujesz w aplikacji`)
};

/**
* | output |
* | --- |
* | "Pay and cancel in the app" |
*
* @param {Coaches_Page_Fact_PayInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_fact_pay = /** @type {((inputs?: Coaches_Page_Fact_PayInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Fact_PayInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_fact_pay(inputs)
	return en_coaches_page_fact_pay(inputs)
});